import { ChevronRight, Copy, Headset, LogOut, RotateCw } from "lucide-react";
import { useSite } from "../../lib/site";
import { toast } from "sonner";
import { BottomNav } from "../../components/laxmi/Chrome";
import { money, when } from "../../lib/api";

const ic = n => `/assets/ic_${n}.png`;
const uidOf = id => String(parseInt(id.slice(-7), 16) % 100000000).padStart(8, "2");
const QUICK = [["ARWallet", "arwallet", "deposit"], ["Deposit", "deposit", "deposit"], ["Withdraw", "withdraw", "withdraw"], ["VIP", "vip", null]];
const CARDS = [["Game History", "My game history", "gamehistory", "gamehistory"], ["Transaction", "My transaction history", "transaction", "history"], ["Deposit", "My deposit history", "dephistory", "history"], ["Withdraw", "My withdraw history", "deposit", "history"]];

function Wagering({ bonus, setPage }) {
  if (!bonus?.active) return null;
  return (
    <section className="wager-card" data-testid="account-wagering-card" onClick={() => setPage("wingo")}>
      <div className="wager-top"><b>{bonus.title}</b><span>{bonus.pct}%</span></div>
      <div className="progress"><span style={{ width: `${bonus.pct}%` }} /></div>
      <small data-testid="account-wagering-text">Wagering {money(bonus.progress)} / {money(bonus.required)} · Withdraw unlocks at 100%</small>
    </section>
  );
}

export default function Account({ data, setPage, onLogout, onRefresh }) {
  const { site } = useSite();
  const tg = (site.support_contact || "@laxmiwin9090").trim();
  const tgUrl = `https://t.me/${tg.replace(/^@/, "").replace(/^https?:\/\/t\.me\//, "")}`;
  const unread = data.notifications.filter(n => !n.read).length;
  const uid = uidOf(data.user.id);
  const copy = () => { navigator.clipboard?.writeText(uid); toast.success("UID copied"); };
  return (
    <div className="screen account">
      <section className="acc-top">
        <img className="acc-avatar" src={ic("avatar")} alt="avatar" />
        <div className="acc-info">
          <div className="acc-name"><b data-testid="account-name">{(data.user.name || "MEMBER").toUpperCase()}</b><span className="vip-badge">VIP0</span></div>
          <button className="uid-chip" onClick={copy} data-testid="copy-uid-button">UID <i>|</i> {uid} <Copy size={13} /></button>
          <small>Last login: {when(data.user.last_login)}</small>
        </div>
      </section>
      <section className="acc-balance">
        <span>Total balance</span>
        <div className="acc-amt"><strong data-testid="account-balance">{money(data.wallet.balance)}</strong><button onClick={onRefresh} data-testid="account-refresh-balance"><RotateCw size={18} /></button></div>
        <button className="enter-wallet" onClick={() => setPage("deposit")} data-testid="enter-wallet-button">Enter wallet</button>
        <div className="acc-quick">{QUICK.map(([l, i, p]) => <button key={l} onClick={() => (p ? setPage(p) : toast("VIP levels coming soon"))} data-testid={`account-${l.toLowerCase()}-button`}><img src={ic(i)} alt={l} /><small>{l}</small></button>)}</div>
      </section>
      <Wagering bonus={data.bonus} setPage={setPage} />
      <section className="acc-safe"><img src={ic("safe")} alt="safe" /><div><b>Safe</b><p>The daily interest rate is 0.1%, and the income is calculated once every 1 minutes.</p></div><span className="safe-chip">₹0.00</span><ChevronRight /></section>
      <div className="acc-grid">{CARDS.map(([t, sub, i, p]) => <button key={t} onClick={() => setPage(p)} data-testid={`account-${t.toLowerCase().replaceAll(" ", "-")}-card`}><img src={ic(i)} alt={t} /><div><b>{t}</b><small>{sub}</small></div></button>)}</div>
      <button className="acc-row" onClick={() => setPage("notifications")} data-testid="account-notifications-row"><img src={ic("notification")} alt="notification" /><b>Notification</b>{unread > 0 && <em className="unread-badge" data-testid="unread-badge">{unread}</em>}<ChevronRight /></button>
      <a className="acc-row support-row" href={tgUrl} target="_blank" rel="noreferrer" data-testid="account-support-row"><span className="tg-icon"><Headset size={20} /></span><b>Customer Support<small data-testid="support-telegram-id">Telegram · {tg}</small></b><ChevronRight /></a>
      <button className="logout" onClick={onLogout} data-testid="logout-button"><LogOut /> Logout</button>
      <BottomNav page="account" setPage={setPage} />
    </div>
  );
}
